export const MetadataActions = {
    SET_ALL_METADATA: 'SET_ALL_METADATA',
    SET_FORM_DRAFT_METADATA: 'SET_FORM_DRAFT_METADATA',
    SET_METADATA: 'SET_METADATA',
    SET_IS_FETCHED_WITH_CONTEXT: 'SET_IS_FETCHED_WITH_CONTEXT',
    RESET_METADATA: 'RESET_METADATA',
};

export const METADATA_MODULE = 'METADATA_MODULE';

export enum EButtonType {
    'default' = 'default',
    'primary' = 'primary',
    'text' = 'text',
    'link' = 'link',
}

export enum EFieldActionType {
  DELETE = 'delete',
  UPLOAD = 'upload',
  DOWNLOAD = 'download'
}

export enum EViewType {
  FORM = 'form',
  TABLE = 'table',
  TABS = 'tabs',
  FILTER = 'filter',
  FORM_TABLE = 'form-table',
  REPORT = 'report',
  JASPER_REPORT = 'jasper-report',
}

export enum EAlign {
  left = 'left',
  right = 'right',
  center = 'center'
}

export enum EFieldType {
    // Common types
    DATE = 'DATE',
    TIME = 'TIME',
    STRING = 'STRING',
    TEXT = 'TEXT',
    VALUESET = 'VALUESET',
    MULTIVALUESET = 'MULTIVALUESET',
    PASSWORD = 'PASSWORD',
    NUMBER = 'NUMBER',
    ICON = 'ICON',
    FILE = 'FILE',
    MULTIPART_FILE = 'MULTIPART_FILE',
    LIST_MULTIPART_FILE = 'LIST_MULTIPART_FILE',
    FILE_LIST = 'FILE_LIST',
    FILE_LIST_WITH_SIGNS = 'FILE_LIST_WITH_SIGNS',
    SIGNATURE = 'SIGNATURE',
    SIGNATURE_REFERENCE = 'SIGNATURE_REFERENCE',
    ATTORNEY = 'ATTORNEY',
    COMBINED_STRING = 'COMBINED_STRING',
    BOOLEAN = 'BOOLEAN',
    BOOLEAN_CLASSIC = 'BOOLEAN_CLASSIC',
    COUNTER = 'COUNTER',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE',
    ICON_DOWNLOAD = 'ICON_DOWNLOAD',
    EDITABLE_FIELD = 'EDITABLE_FIELD',
    BREADCRUMB_ITEM = 'BREADCRUMB_ITEM',
    ACTION_DELETE = 'ACTION_DELETE',
    OPEN_MODAL_ACTION = 'OPEN_MODAL_ACTION',
    REPORT_LINK = 'REPORT_LINK',
    REQUEST_LINK = 'REQUEST_LINK',
    DATE_PASSED_INDICATOR = 'DATE_PASSED_INDICATOR',
    NUMBER_SQUARE_PRIMARY = 'NUMBER_SQUARE_PRIMARY',
    NUMBER_SQUARE_DEFAULT = 'NUMBER_SQUARE_DEFAULT',
    RICH_TEXT_RENDERER = 'RICH_TEXT_RENDERER',
    TABLE_ROW_INDEX = 'TABLE_ROW_INDEX',
    REFERENCE_SWITCHER = 'REFERENCE_SWITCHER',
    QUERY_PARAMS_BOUND_SELECT = 'QUERY_PARAMS_BOUND_SELECT',
    STATUS = 'STATUS',
    REPORT_WATCHER = 'REPORT_WATCHER',

    // Form types
    REFERENCE = 'REFERENCE',
    LARGE_STRING_INPUT = 'LARGE_STRING_INPUT',
    INPUT_WITH_DEFAULT_VALUE_SETTER = 'INPUT_WITH_DEFAULT_VALUE_SETTER',
    TEXTAREA = 'TEXTAREA',
    CHECKBOX = 'CHECKBOX',
    CHECKBOX_DATE_GROUP = 'CHECKBOX_DATE_GROUP',
    STATIC_SELECT = 'STATIC_SELECT',
    STRING_SELECT = 'STRING_SELECT',
    LIST = 'LIST',
    GROUP = 'GROUP',
    ARRAY_STRING = 'ARRAY_STRING',
    DYNAMIC_STRING = 'DYNAMIC_STRING',
    CHECKBOX_GROUP = 'CHECKBOX_GROUP',
    DEPENDENTS = 'DEPENDENTS',
    COMBINED_FIELD = 'COMBINED_FIELD',
    COMBINED_FIELD_WITH_DELETE = 'COMBINED_FIELD_WITH_DELETE',
    NUMBER_DEFAULT_BY_CREATE = 'NUMBER_DEFAULT_BY_CREATE',
    FIELD_BLOCK = 'FIELD_BLOCK',
    UPLOAD_FILE = 'UPLOAD_FILE',
    ICON_LINK = 'ICON_LINK',
    BOOLEAN_DELETE = 'BOOLEAN_DELETE',
    BOOLEAN_STRING = 'BOOLEAN_STRING',
    ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION',
    OPEN_EDIT_MODAL = 'OPEN_EDIT_MODAL',
    RICH_TEXT = 'RICH_TEXT',
    TIME_WITH_LABEL_INSIDE = 'TIME_WITH_LABEL_INSIDE',
    OPEN_MODAL = 'OPEN_MODAL',
    FIELDS_TREE = 'FIELDS_TREE',
    FIELDS_TREE_CHILD = 'FIELDS_TREE_CHILD',
    CUSTOM_SELECT = 'CUSTOM_SELECT',
    TABLE_DATA_SWITCHER = 'TABLE_DATA_SWITCHER',
    DISPLAY_ADDITIONAL_TABLE = 'DISPLAY_ADDITIONAL_TABLE',
    INPUT_TOOLTIP = 'INPUT_TOOLTIP',

    // Table types
    FILE_DOWNLOAD_LINK = 'FILE_DOWNLOAD_LINK',
    SIGNATURE_DOWNLOAD_LINK = 'SIGNATURE_DOWNLOAD_LINK',
    COMBINED_STRING_DATE = 'COMBINED_STRING_DATE',
    SIGNATURE_UPLOAD_CELL = 'SIGNATURE_UPLOAD_CELL',
    FILE_UPLOAD_CELL = 'FILE_UPLOAD_CELL',
    UPLOAD_SCAN_FILES = 'UPLOAD_SCAN_FILES',

    // Editable table types
    INPUT_NUMBER='INPUT_NUMBER',
    // Dashboard types
    BAR_STATISTICS = 'BAR_STATISTICS',
    CIRCLE_STATISTICS = 'CIRCLE_STATISTICS',
    HALF_CIRCLE_STATISTICS = 'HALF_CIRCLE_STATISTICS',
    PROGRESS_LIST_STATISTICS = 'PROGRESS_LIST_STATISTICS',
    PROGRESS_LIST_STATISTICS_SECONDARY = 'PROGRESS_LIST_STATISTICS_SECONDARY',

    // administration.report.configuration types
    OPEN_REPORT_CONFIGURATION_FORM = 'OPEN_REPORT_CONFIGURATION_FORM',
    OPEN_REPORT_CONFIGURATION_HISTORY_MODAL = 'OPEN_REPORT_CONFIGURATION_HISTORY_MODAL',

    // ais3.monitor.services
    AIS3_MS_REQUEST_CONTENT = 'AIS3_MS_REQUEST_CONTENT',
    AIS3_MS_RESPONSE_CONTENT = 'AIS3_MS_RESPONSE_CONTENT',
    OPEN_DOCUMENT_CODES_MODAL = 'OPEN_DOCUMENT_CODES_MODAL',
    INPUT_WITH_POST_BUTTON = 'INPUT_WITH_POST_BUTTON',

    // tableReportFilter
    MULTI_VALUE_SET = 'MULTIVALUESET',

    // administration.accounts.fns
    EXTERNAL_EMPLOYEE_BOOL = 'EXTERNAL_EMPLOYEE_BOOL',

    // flex fields types administration.dff
    OPEN_FLEX_FIELDS_SETTINGS_PAGE = 'OPEN_FLEX_FIELDS_SETTINGS_PAGE',
    EXTERNAL_SYSTEMS_MODAL = 'EXTERNAL_SYSTEMS_MODAL',

    // Factor Influence Info
    FACTOR_INFLUENCE_INFO_DETAIL_BUTTON = 'FACTOR_INFLUENCE_INFO_DETAIL_BUTTON',
    FACTOR_INFLUENCE_INFO_DATE_BUTTON = 'FACTOR_INFLUENCE_INFO_DATE_BUTTON',
    FACTOR_INFLUENCE_STATUS = 'FACTOR_INFLUENCE_STATUS',


    // Project Investment Info
    PROJECT_INVESTMENT_INFO_DETAIL_BUTTON = 'PROJECT_INVESTMENT_INFO_DETAIL_BUTTON',
    PROJECT_INVESTMENT_INFO_DATA_BUTTON = 'PROJECT_INVESTMENT_INFO_DATA_BUTTON',
}

export enum EMetaActionType {
  // Common types
  SUBMENU = 'SUBMENU',
  SUBMENU_OPTION = 'SUBMENU_OPTION',
  OPEN_MODAL = 'OPEN_MODAL',
  FILTER = 'FILTER',
  SEARCH = 'SEARCH',
  SEND_REQUEST = 'SEND_REQUEST',
  // Table types
  ACTION_FOR_TABLE = 'ACTION_FOR_TABLE',
  ACTION_FOR_TABLE_ROWS = 'ACTION_FOR_TABLE_ROWS',
  DELETE_TABLE_ROWS = 'DELETE_TABLE_ROWS',
  DOWNLOAD_TABLE_ROWS = 'DOWNLOAD_TABLE_ROWS',
  BUTTON_ACTION_SAVE_TABLE_ROWS = 'BUTTON_ACTION_SAVE_TABLE_ROWS',
  DOWNLOAD_REPORT = 'DOWNLOAD_REPORT',
  BUTTON_SAVE_EDITABLE_MODAL = 'BUTTON_SAVE_EDITABLE_MODAL',
  GENERATE_TC_DEMAND_RESPONSE = 'GENERATE_TC_DEMAND_RESPONSE',
  GENERATE_TC_DEMAND_RESPONSE_NO_REDIRECT = 'GENERATE_TC_DEMAND_RESPONSE_NO_REDIRECT',
  BUTTON_SAVE_FORM_PERSONAL_ACCOUNT='BUTTON_SAVE_FORM_PERSONAL_ACCOUNT',
  /**
   * Кнопка для отправки запроса на копирование в ais3.response.requirement
   */
  SEND_REQUEST_COPY_RESPONSE_REQUIREMENT='SEND_REQUEST_COPY_RESPONSE_REQUIREMENT',
  /**
   * Кнопка для отправки запроса с selectedRows и userName
   */
  SEND_REQUEST_WITH_USER='SEND_REQUEST_WITH_USER',
  // Form types
  /**
   * Кнопка сохранения.
   * Вызывает событие submit. Обработчиков на ней нет.
   */
  BUTTON_SAVE_FORM = 'BUTTON_SAVE_FORM',
  BUTTON_CLEAN_FORM = 'BUTTON_CLEAN_FORM',
  BUTTON_SAVE_OR_EDIT_FORM = 'BUTTON_SAVE_OR_EDIT_FORM',
  BUTTON_SEND_FILTER = 'BUTTON_SEND_FILTER',
  BUTTON_DOWNLOAD_FILE = 'BUTTON_DOWNLOAD_FILE',
  BUTTON_DOWNLOAD_DOCUMENT_FILE = 'BUTTON_DOWNLOAD_DOCUMENT_FILE',
  BUTTON_SET_EDIT_MODE = 'BUTTON_SET_EDIT_MODE',
  LAUNCH_PROGRAM = 'LAUNCH_PROGRAM',
  /**
   * Кнопка для запроса на получение данных из ЦФТ
   */
  BUTTON_FOR_CFT = 'BUTTON_FOR_CFT',
  /**
   * Кнопка для изменения статуса
   */
  BUTTON_CHANGE_REQUEST_STATUS = 'BUTTON_CHANGE_REQUEST_STATUS',
  OPEN_REQUESTS_CHILD_MODAL = 'OPEN_REQUESTS_CHILD_MODAL',
  BUTTON_OPEN_MODAL_WITH_QUERY_PARAMS = 'BUTTON_OPEN_MODAL_WITH_QUERY_PARAMS',
  BUTTON_CONFIRM = 'BUTTON_CONFIRM',
  /**
   * Скачать все
   */
  BUTTON_DOWNLOAD_ALL = 'BUTTON_DOWNLOAD_ALL',
  CREATE_LIST_CP = 'CREATE_LIST_CP',
  SEND_REMINDER = 'SEND_REMINDER',
  UNLOAD_CP = 'UNLOAD_CP',
  UPLOAD_FROM_EXCEL = 'UPLOAD_FROM_EXCEL',
  UPLOAD_FROM_XML = 'UPLOAD_FROM_XML',
  DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE',
  DOWNLOAD_ALL_EXCEL = 'DOWNLOAD_ALL_EXCEL',
  EDIT_FIELD = 'EDIT_FIELD',
  BUTTON_SAVE_ROWS = 'BUTTON_SAVE_ROWS',
  DOWNLOAD_EXCEL = 'DOWNLOAD_EXCEL',
  DOWNLOAD_XML = 'DOWNLOAD_XML',
  CHECKBOX_CONFIRM = 'CHECKBOX_CONFIRM',
  BUTTON_COPY_RULES_FROM_LAST_PERIOD = 'BUTTON_COPY_RULES_FROM_LAST_PERIOD',
  BUTTON_DOWNLOAD_SELECTED_ROWS = 'BUTTON_DOWNLOAD_SELECTED_ROWS',
  BUTTON_UPDATE = 'BUTTON_UPDATE',
  BUTTON_BACK = 'BUTTON_BACK',
  UPLOAD_SCAN_FILES = 'UPLOAD_SCAN_FILES',
  /**
   * сбрасывает данные в карточке до тех что пришли первоначально
   * */
  BUTTON_SET_INITIAL_DATA = 'BUTTON_SET_INITIAL_DATA',

  BUTTON_EDIT_FORM = 'BUTTON_EDIT_FORM',
  REMOVE_FILTER = 'REMOVE_FILTER',
  BUTTON_CONTROL_COLLAPSE = 'BUTTON_CONTROL_COLLAPSE',
  /**
   * Действия для работы с документами
   * */
  UPDATE_DOCUMENTS_STATUS = 'UPDATE_DOCUMENTS_STATUS',
  PUBLISH_LIST = 'PUBLISH_LIST',
  BUTTON_OPEN_LINK = 'BUTTON_OPEN_LINK',
  BUTTON_SET_CORR_NUMBER = 'BUTTON_SET_CORR_NUMBER',
  DOWNLOAD_ZIP_TABLE_ROWS = 'DOWNLOAD_ZIP_TABLE_ROWS',
  CALCULATE_CONTROL_RATIO = 'CALCULATE_CONTROL_RATIO',
  OPEN_DOCUMENT_XML_MODAL = 'OPEN_DOCUMENT_XML_MODAL',
  OPEN_SYNTHESIS_DOCUMENT_MODAL = 'OPEN_SYNTHESIS_DOCUMENT_MODAL',
  OPEN_CRYPTO_PRO_SIGNING_MODAL = 'OPEN_CRYPTO_PRO_SIGNING_MODAL',
  SEND_SELECTED_DOCS_IDS = 'SEND_SELECTED_DOCS_IDS',
  /**
   * удаляет запись реестра через карточку
   * */
  BUTTON_DELETE_ELEMENT = 'BUTTON_DELETE_ELEMENT',
  BUTTON_SWITCH_TABS = 'BUTTON_SWITCH_TABS',
  BUTTON_DELETE_TAB = 'BUTTON_DELETE_TAB',
  BUTTON_HISTORY_BACK = 'BUTTON_HISTORY_BACK',
  BUTTON_REDIRECT = 'BUTTON_REDIRECT',
  BUTTON_CLEAR_FORM = 'BUTTON_CLEAR_FORM',
  /**
   * кнопки для работы с отчетами
   * */
  BUTTON_DOWNLOAD_REPORT = 'BUTTON_DOWNLOAD_REPORT',
  BUTTON_OPEN_SIMPLE_MODAL = 'BUTTON_OPEN_SIMPLE_MODAL',
  BUTTON_ATTACHMENT = 'BUTTON_ATTACHMENT',
  /**
   * кнопки для работы с запросами
   * */
  BUTTON_SEND_FOR_APPROVAL_REQUEST = 'BUTTON_SEND_FOR_APPROVAL_REQUEST',
  BUTTON_SEND_FOR_APPROVAL_REQUEST_DRAFT = 'BUTTON_SEND_FOR_APPROVAL_REQUEST_DRAFT',
  BUTTON_SEND_COMMENT_ON_THE_REQUEST = 'BUTTON_SEND_COMMENT_ON_THE_REQUEST',
  BUTTON_MARK_ALL_AS_READ = 'BUTTON_MARK_ALL_AS_READ',
  CREATE_RESPONSE_DRAFT = 'CREATE_RESPONSE_DRAFT',
  CREATE_PROLONGATION_REQUEST_DRAFT = 'CREATE_PROLONGATION_REQUEST_DRAFT',
  BUTTON_SAVE_FORM_DRAFT = 'BUTTON_SAVE_FORM_DRAFT',
  BUTTON_MARK_AS_READ = 'BUTTON_MARK_AS_READ',
  BUTTON_SEND_TO_AGREEMENT = 'BUTTON_SEND_TO_AGREEMENT',
  API_REQUEST_BUTTON = 'API_REQUEST_BUTTON',

  OPEN_FORM = 'OPEN_FORM',
  BUTTON_OPEN_SIMPLE_FILTER = 'BUTTON_OPEN_SIMPLE_FILTER',
  SIMPLE_CHECKBOX = 'SIMPLE_CHECKBOX',
  /**
   * кнопки для работы с СВК
   * */
  BUTTON_UPDATE_CP = 'BUTTON_UPDATE_CP',
  BUTTON_SAVE_EDITABLE_TABLE = 'BUTTON_SAVE_EDITABLE_TABLE',
  CLEAR_TABLE_ROWS = 'CLEAR_TABLE_ROWS',

  // кастомные кнопки формы пользователей и ролей (administration.accounts.fns)
  BUTTON_BLOCK_USER = 'BUTTON_BLOCK_USER',
  // Кнопка запуска программы в отвязке от меты
  LAUNCH_PROGRAM_BUTTON = 'LAUNCH_PROGRAM_BUTTON',

  /**
   * универсальные ссылки
   * */
  CUSTOM_LINK = 'CUSTOM_LINK',

  /**
   * Универсальная ссылка, формирующаяся по строке таблицы
   * */
  CUSTOM_LINK_TABLE_ROW = 'CUSTOM_LINK_TABLE_ROW',

  /**
   * Отправляет запрос на формирования агрегата
   * Используется в разделах Бухгалтерского учета
   * */
  FORMATION_AGGREGATE = 'FORMATION_AGGREGATE',

  /**
   * Открывает модальное окно для обновления данных по 4 и 8 сценариям
   * */
  OPEN_DWH_DATA_PREPARATION_MODAL = 'OPEN_DWH_DATA_PREPARATION_MODAL',

  /**
   * Кнопки для работы с формой Сведения о макроэкономических факторах
   * */

  OPEN_FACTOR_INFLUENCE_INFO_ITEM_MODAL = 'OPEN_FACTOR_INFLUENCE_INFO_ITEM_MODAL',

  OPEN_FACTOR_INFLUENCE_INFO_SERVICE_MODAL = 'OPEN_FACTOR_INFLUENCE_INFO_SERVICE_MODAL',

  OPEN_FACTOR_INFLUENCE_INFO_DELETE_ROWS_MODAL = 'OPEN_FACTOR_INFLUENCE_INFO_DELETE_ROWS_MODAL',


  /**
   * Кнопки для работы с формой Сведения об инвестиционных проектах
   * */

  OPEN_PROJECT_INVESTMENT_SERVICE_MODAL = 'OPEN_PROJECT_INVESTMENT_SERVICE_MODAL',

  OPEN_PROJECT_INVESTMENT_INFO_MODAL = 'OPEN_PROJECT_INVESTMENT_INFO_MODAL',

  OPEN_PROJECT_INFLUENCE_INFO_DELETE_ROWS_MODAL = 'OPEN_PROJECT_INFLUENCE_INFO_DELETE_ROWS_MODAL',
}
